export default "__VITE_ASSET__089e6d45__"